import { InstanceDataConfig } from "charts/src/types/chart";
import sortBy from "lodash/sortBy";

import { ChartData } from "@/features/analysis/services/get-chart-config-details";

import { DUMMY_RANGE } from "../../data/chart-configs";
import { getRevenueBreakdownTranslation } from "../../data/tmp-translation";
import { chartTypeOverylaySorter } from "../shared";
import { ConverterInput } from "../types";

const DISPLAY_COUNT = 4;
const DISPLAY_COUNT_FULL_WIDTH = 12;

function getDisplayChartDatas(
  chartDatas: ChartData[],
  displayCount: number
): ChartData[] {
  if (chartDatas.length <= displayCount + 1) {
    return chartDatas;
  }

  const sortedChartDatas = sortBy(chartDatas, ({ data }) => {
    const { value } = data[data.length - 1];
    return typeof value === "number" ? -value : Infinity;
  });

  const displayChartDatas = sortedChartDatas.slice(0, displayCount);
  const otherChartData = sortedChartDatas.slice(displayCount);

  if (otherChartData.length > 0) {
    displayChartDatas.push({
      ...displayChartDatas[0],
      label: "Other",
      data: otherChartData
        .slice(1)
        .reduce<ChartData["data"]>((acc, currentDataInstance) => {
          return acc.map((accItem, index) => {
            const currentDataPointValue =
              currentDataInstance.data[index]?.value ?? 0;
            return {
              ...accItem,
              value: Number(accItem.value) + Number(currentDataPointValue),
            };
          });
        }, otherChartData[0].data),
    });
  }
  return displayChartDatas;
}

export const revenueBreakdownChartInstanceDataConfig = (
  inputParams: ConverterInput
): InstanceDataConfig[] => {
  const { chartConfigDetails, mode } = inputParams;

  const displayChartDatas = getDisplayChartDatas(
    chartConfigDetails.chartDatas,
    mode === "grid" ? DISPLAY_COUNT : DISPLAY_COUNT_FULL_WIDTH
  );

  return displayChartDatas
    .map(({ valueFormatType, chartType, axis, groupType, unit }) => {
      return {
        valueFormatType,
        chartType,
        groupType,
        yAxisID: axis,
        unit: unit ?? undefined,
        unitAxisType: "side" as const,
      };
    })
    .sort(chartTypeOverylaySorter);
};

export const revenueBreakdownChartInstanceData = (
  inputParams: ConverterInput
) => {
  const { chartConfigDetails, timeFrame, mode } = inputParams;

  const displayChartDatas = getDisplayChartDatas(
    chartConfigDetails.chartDatas,
    mode === "grid" ? DISPLAY_COUNT : DISPLAY_COUNT_FULL_WIDTH
  );

  return displayChartDatas
    .slice()
    .sort(chartTypeOverylaySorter)
    .map((chartData) => {
      return {
        [DUMMY_RANGE]: {
          [timeFrame]: chartData.data,
        },
      };
    });
};

export const revenueBreakdownChartInstanceLabels = (
  inputParams: ConverterInput
) => {
  const { chartConfigDetails, symbol, lang, mode } = inputParams;

  const displayChartDatas = getDisplayChartDatas(
    chartConfigDetails.chartDatas,
    mode === "grid" ? DISPLAY_COUNT : DISPLAY_COUNT_FULL_WIDTH
  );

  const labels = displayChartDatas.map((chartData) => {
    return getRevenueBreakdownTranslation(symbol, chartData.label, lang);
  });

  return labels;
};
